import server from 'utils/request';

// 仲裁员接口
/**
 * 仲裁员案件列表
 * @param data
 */
export function arbitorCase(data) {
  return server({
    url: '/case/query/arbitor',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 仲裁员案件详情
 * @param data
 */
export function arbitorCaseDetails(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/query/details',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 仲裁员提出问题
 * @param data
 */
export function raise(data) {
  return server({
    url: '/case/question/raise',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 仲裁员提出问题
 * @param data
 */
export function sendMessage(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/question/sendQuestionList',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 仲裁员问题列表
 * @param caseTempNo
 */
export function questionList(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/question/list',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 起草裁决书
 * @param caseTempNo
 */
export function createAward(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/judge/createAward',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取裁决书
 * @param caseTempNo
 */
export function getAwardInfo(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/judge/getAwardInfo',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 签章
 * @param caseTempNo
 */
export function signet(data) {
  return server({
    url: 'case/judge/sealAwardJudge',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}


/**
 * 保存裁决书
 * @param data
 */
export function updateAward(data) {
  return server({
    url: '/case/judge/updateAward',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 提交裁决书
 * @param data
 */
export function submitAward(data) {
  return server({
    url: '/case/judge/submitAward',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 审核裁决书-退回
 * @param data
 */
export function check(data) {
  return server({
    url: '/case/judge/checkAward',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 审核 仲裁员回避审核、管辖异议审核、反请求审核
 * @param data
 */
export function powerDetails(data) {
  return server({
    url: '/case/power/details',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 审核管辖异议
 */
export function checkDissent(data) {
  return server({
    url: '/case/power/checkDissent',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 审核仲裁员回避
 */
export function checkAvoid(data) {
  return server({
    url: '/case/power/checkAvoid',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 审核反请求
 */
export function checkReverser(data) {
  return server({
    url: '/case/power/checkReverser',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 审核和解
 */
export function checkCompromise(data) {
  return server({
    url: '/case/power/chackCompromise',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 声明
 */
export function statement(data) {
  return server({
    url: '/case/trial/statement',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}



// WEBPACK FOOTER //
// ./src/api/arbitrator/arbitrator.js